(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rh-back-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-rh-back]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    const referrer = document.referrer;
    if (!referrer || window.history.length <= 1) return;

    let sameSite = false;
    try {
      const from = new URL(referrer);
      sameSite = from.origin === window.location.origin && from.href !== window.location.href;
    } catch (error) {
      sameSite = false;
    }

    if (sameSite) {
      event.preventDefault();
      window.history.back();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
